/*
 * (C) Behaviour Interactive Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * This file is proprietary and confidential
 */

export function getWindowStatus(): boolean {
  return typeof window !== 'undefined';
}
